import { DataGrid, GridColDef, GridRowClassNameParams } from "@mui/x-data-grid"
import { Block, Add } from "@mui/icons-material"
// @ts-ignore
import Edit from "../../assets/Edit.svg?react"
import { Box, Button } from "@mui/material"
import OpCoOnboardForm from "../OpCoOnboardForm/OpCoOnboardForm"

import {
    Wrapper,
    HeaderWrapper,
    Header,
    Subheader,
    DataGridWrapper,
} from "./OpCoTable.styles"
import {
    OperatingCompanyRead,
} from "../../api/generated"
import { useState } from "react"
import OpCoEditForm from "../OpCoEditForm/OpCoEditForm"
import { selectLGInternalUser } from "../../activeScreenSlice"
import { useAppSelector } from "../../app/hooks"

export interface Iprops {
    allOpcosQuery: {
        data: OperatingCompanyRead[] | undefined;
        isLoading: boolean;
        isError: boolean;
        error: Error | null;
    }
}

export default function OpCoTable({
    allOpcosQuery
}: Iprops) {
    const { data, isLoading, isError, error } = allOpcosQuery
    const rows = data
    const [formMode, setFormMode] = useState('display')
    const [selectedMember, setSelectedMember] = useState(null);
    const LGInternalUser = useAppSelector(selectLGInternalUser);

    const handleEditButton = (member) => {
        setFormMode("edit")
        setSelectedMember(member)
    }
    const handleCancelButton = () => {
        setFormMode("display")
    }
    const handleBlockButton = () => {
        //block button logic
    }
    const handleCreateOpCoForm = () => {
        setFormMode('create')
    }

    const columns: Array<GridColDef> = [
        {
            field: "description",
            headerName: "Business Unit Name",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: "opco_code",
            headerName: "Business Unit Code",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
            minWidth: 50,
        },
        {
            field: "invoiceemailid",
            headerName: "Email",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: "created_at",
            headerName: "Creation Date",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
            valueFormatter: (params) => {
                const value = params.value;
                if (!value) return '';
                const date = new Date(value);
                const pad = (n) => n.toString().padStart(2, '0');
                return `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()}`;
            }
        },
        {
            field: "actions",
            headerName: '',
            align: 'right',
            headerAlign: 'right',
            sortable: false,
            disableColumnMenu: true,
            renderCell: ({ row: member }) => (
                <Edit style={{ cursor: 'pointer', paddingRight: '40px'}} onClick={() => handleEditButton(member)} />
            )
        },
    ]

    const noDataStyles = { height: data.length<1 ? 600 : '', width: data.length<1 ? '100%': '' };

    if (isLoading) {
        return <p>Loading business units...</p>;
    }

    if (isError) {
        return <p>Error loading business units: {error.message}</p>;
    }
    return (
        <>
            {
                formMode === "display" ? (
                    <Wrapper>
                        <HeaderWrapper >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center', mb: 2 }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Header sx={{ display: 'inline' }}>Business unit</Header>
                                    <Subheader sx={{ display: 'inline' }}>List of created business units </Subheader>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Button
                                        onClick={handleCreateOpCoForm}
                                        variant="outlined"
                                        startIcon={<Add />}
                                        sx={{
                                        '& .MuiButton-startIcon': {
                                            mr: .5
                                        }
                                    }}
                                    disabled = {LGInternalUser}
                                    >
                                        Create Business Unit
                                    </Button>
                                </Box>
                            </Box>
                        </HeaderWrapper>
                        <DataGridWrapper>
                            <div style={noDataStyles}>
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                getRowClassName={(e: GridRowClassNameParams<any>) => e.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"}
                                pageSizeOptions={[10, 20, 50, 100]}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                sx={{
                                    border: "none",
                                    '& .MuiDataGrid-cell, & .MuiDataGrid-root, & .MuiDataGrid-columnHeaders': {
                                        borderBottom: 'none',
                                    },
                                    '& .MuiDataGrid-cell': {
                                        padding: '0',
                                    },
                                    '& .MuiDataGrid-cell:first-of-type': {
                                        padding: '0 0 0 50px',
                                    },
                                    '& .MuiDataGrid-columnHeader': {
                                        padding: '0',
                                    },
                                    '& .MuiDataGrid-columnHeader:first-of-type': {
                                        padding: '0 0 0 50px',
                                    },
                                    '& .MuiDataGrid-row.even-row': {
                                        backgroundColor: 'var(--background-off-white)',
                                    },
                                    '& .MuiDataGrid-cellContent': {
                                        fontSize: '13px',
                                    },
                                }}

                            />
                            </div>
                        </DataGridWrapper>
                    </Wrapper>
                ) : formMode === "create" ? (<OpCoOnboardForm onCancelOpco={handleCancelButton} />) : (
                    <OpCoEditForm selectedMember={selectedMember} onCancelOpco={handleCancelButton} />
                )
            }
        </>

    )
}
